module.exports = __webpack_public_path__ + "img/start_scan_large.4e0cce5d.svg";